import { Route } from '@angular/router';
import { MainLayoutComponent } from './core/layout/main-layout/main-layout.component';
import { isAuthenticatedGuard } from './shared/guard/is-authenticated.guard';

export const appRoutes: Route[] = [
  {
    path: 'auth',
    loadChildren: () =>
      import('./page/auth/auth.routes').then(m => m.authRoutes),
  },
  {
    path: '',
    component: MainLayoutComponent,
    canActivate: [isAuthenticatedGuard()],
    children: [
      {
        path: '',
        redirectTo: 'shero-squad',
        pathMatch: 'full'
      },
      {
        path: 'shero-squad',
        loadChildren: () => import('./page/shero-squad/routes').then(m => m.routes),
        canActivate: [isAuthenticatedGuard()]
      },
      {
        path: 'users',
        loadChildren: () => import('./page/users/routes').then(m => m.routes),
        canActivate: [isAuthenticatedGuard()]
      },
      {
        path: 'meetings',
        loadChildren: () => import('./page/meetings/routes').then(m => m.routes),
        canActivate: [isAuthenticatedGuard()]
      },
      {
        path: 'milestones',
        loadChildren: () => import('./page/milestones/routes').then(m => m.routes),
        canActivate: [isAuthenticatedGuard()]
      },
      {
        path: 'questionnaires',
        loadChildren: () => import('./page/questionnaires/routes').then(m => m.routes),
        canActivate: [isAuthenticatedGuard()]
      },
      {
        path: 'contact-requests',
        loadChildren: () => import('./page/contact-requests/routes').then(m => m.routes),
        canActivate: [isAuthenticatedGuard()]
      },
      {
        path: 'account',
        loadChildren: () =>
          import('./page/settings/routes').then(m => m.routes),
        canActivate: [isAuthenticatedGuard()]
      },
    ],
  },
];
